// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `spline-viewer {
  height: 110%;
  opacity: 0.6;
}
@media only screen and (max-width: 1199px) {
  spline-viewer {
    opacity: 0.25;
  }
}

section {
  min-height: 100svh;
  padding-top: var(--header-height);
  padding-bottom: 10%;
}
section:after {
  background: linear-gradient(to top, #121212 0%, transparent);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 10%;
  z-index: 1;
}
@media only screen and (max-width: 1199px) {
  section {
    height: initial;
    padding-top: 8rem;
    max-width: 100%;
    overflow: hidden;
  }
}

.background-gradient {
  z-index: 0;
}

.image-youtube {
  aspect-ratio: 560/315;
  display: flex;
}
@media only screen and (min-width: 1200px) {
  .image-youtube {
    margin-left: 17px;
    max-width: 560px;
    max-height: 315px;
  }
}

.fa-shopify {
  color: #85b043;
}

.video-playing app-image,
.video-playing button {
  display: none !important;
}

.fa-shopify,
.shopify-container span {
  filter: drop-shadow(2px 4px 6px black);
}

.title-primary {
  line-height: 1.4;
  letter-spacing: 2.6px;
}

.title-overlay {
  letter-spacing: 2.6px;
  mix-blend-mode: color-burn;
  color: #bdc6d2;
  filter: drop-shadow(2px 4px 6px black);
  background: linear-gradient(167deg, #844b92, #d49a20);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.partners-container {
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  border: 1px solid rgba(236, 239, 241, 0.2);
  background: rgba(214, 214, 214, 0.35);
}

p.text-base {
  filter: drop-shadow(2px 4px 6px black);
}

.text-column p {
  line-height: 1.8;
}

.buttons-column > *:last-child {
  flex: 0 0 clamp(120px, 100%, 240px);
}
.buttons-column > *:last-child:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 50px;
  background: #fff;
}
@media only screen and (max-width: 1199px) {
  .buttons-column > *:last-child:before {
    top: 0;
    left: 50%;
    translate: -50% 0%;
    width: 50px;
    height: 1px;
  }
}

.trustpilot-container {
  left: -3px;
}
.trustpilot-container:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  width: 50px;
  height: 1px;
  background: #fff;
}

@keyframes slide-left-to-middle {
  0% {
    translate: -110% 0;
    opacity: 0;
  }
  100% {
    translate: 0 0;
    opacity: 1;
  }
}
@media only screen and (min-width: 1200px) {
  :host ::ng-deep .trustpilot {
    animation: slide-left-to-middle 1s ease-in-out forwards;
  }
}
:host ::ng-deep .p-button span {
  white-space: nowrap;
}
:host ::ng-deep .trustpilot {
  max-width: 240px;
}

.play-ytb {
  transform: translate(-50%, -50%);
  width: 80px;
  height: 50px;
  background: 0 0;
}
.play-ytb span {
  visibility: hidden;
}

.image-youtube app-image {
  display: block;
  width: 100%;
}
.image-youtube:before {
  content: "";
  position: absolute;
  border: 1px solid #fff;
  inset: -1px;
  z-index: -1;
  box-shadow: -6px 0 12px 0 rgba(212, 154, 32, 0.2), 0 -6px 12px 0 rgba(212, 154, 32, 0.2);
  transition: inset 0.2s ease-in-out;
}
@media only screen and (min-width: 1200px) {
  .image-youtube:before {
    animation: slide-middle-to-top 0.5s ease-in-out forwards;
  }
}

@keyframes slide-middle-to-top {
  0% {
    inset: -1px;
  }
  100% {
    inset: -1rem;
  }
}
.fade-out {
  opacity: 0;
  transition: opacity 1s ease;
}

.slide-middle-to-down {
  transform: translateY(50%);
  opacity: 0;
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-up {
  transform: translateY(-50%);
  opacity: 0;
  transition: transform 0s ease, opacity 0s ease;
}

.slide-top-to-middle {
  transform: translateY(0);
  opacity: 1;
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.custom-shape-divider-bottom-1719869309 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
}

.custom-shape-divider-bottom-1719869309 svg {
  position: relative;
  display: block;
  width: calc(129% + 1.3px);
  height: 90px;
}

.custom-shape-divider-bottom-1719869309 .shape-fill {
  fill: #121212;
}

@media only screen and (max-width: 1199px) {
  :host::ng-deep .image-youtube iframe {
    max-width: 100%;
    aspect-ratio: 16/9;
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/intro-banner/intro-banner.component.scss"],"names":[],"mappings":"AAYA;EACE,YAAA;EACA,YAAA;AAXF;AAFE;EAWF;IAKI,aAAA;EAVF;AACF;;AAaA;EACE,kBAAA;EACA,iCAAA;EACA,mBAAA;AAVF;AAYE;EACE,4DAAA;EAEA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AAXJ;AAtBE;EAoBF;IAiBI,eAAA;IACA,iBAAA;IACA,eAAA;IACA,gBAAA;EAXF;AACF;;AAcA;EACE,UAAA;AAXF;;AAcA;EACE,qBAAA;EACA,aAAA;AAXF;AAjCE;EA0CF;IAKI,iBAAA;IACA,gBAAA;IACA,iBAAA;EAVF;AACF;;AAaA;EACE,cAAA;AAVF;;AAcE;;EAEE,wBAAA;AAXJ;;AAeA;;EAEE,sCAAA;AAZF;;AAeA;EACE,gBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,qBAAA;EACA,0BAAA;EACA,cAAA;EACA,sCAAA;EACA,qDAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,kCAAA;EACA,0BAAA;EACA,0CAAA;EACA,qCAAA;AAZF;;AAeA;EACE,sCAAA;AAZF;;AAgBE;EACE,gBAAA;AAbJ;;AAkBE;EACE,mCAAA;AAfJ;AAiBI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EAGA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAfN;AA3GE;EAgHE;IAaI,MAAA;IACA,SAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;EAdN;AACF;;AAmBA;EACE,UAAA;AAhBF;AAkBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE;IACE,kBAAA;IACA,UAAA;EAjBF;EAmBA;IACE,cAAA;IACA,UAAA;EAjBF;AACF;AAtIE;EA4JE;IACE,uDAAA;EAnBJ;AACF;AAsBE;EACE,mBAAA;AApBJ;AAuBE;EACE,gBAAA;AArBJ;;AAyBA;EAGE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAtBF;AAwBE;EACE,kBAAA;AAtBJ;;AA2BE;EACE,cAAA;EACA,WAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,wFAAA;EACA,kCAAA;AAzBJ;AA3KE;EA6LA;IAUI,wDAAA;EAxBJ;AACF;;AA4BA;EACE;IACE,WAAA;EAzBF;EA2BA;IACE,YAAA;EAzBF;AACF;AA4BA;EACE,UAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,0BAAA;EACA,UAAA;EACA,kDAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,UAAA;EACA,8CAAA;AA1BF;;AA6BA;EACE,wBAAA;EACA,UAAA;EACA,kDAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,aAAA;AA1BF;;AA1OE;EAyQE;IACE,eAAA;IACA,kBAAA;IACA,YAAA;EA3BJ;AACF","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin mu() {\r\n  @media only screen and (min-width: 1200px) {\r\n    @content;\r\n  }\r\n}\r\n\r\nspline-viewer {\r\n  height: 110%;\r\n  opacity: 0.6;\r\n\r\n  @include md() {\r\n    opacity: 0.25;\r\n  }\r\n}\r\n\r\nsection {\r\n  min-height: 100svh;\r\n  padding-top: var(--header-height);\r\n  padding-bottom: 10%;\r\n\r\n  &:after {\r\n    background: linear-gradient(to top, #121212 0%, transparent);\r\n    //content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: 10%;\r\n    z-index: 1;\r\n  }\r\n\r\n  @include md() {\r\n    height: initial;\r\n    padding-top: 8rem;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n.background-gradient {\r\n  z-index: 0;\r\n}\r\n\r\n.image-youtube {\r\n  aspect-ratio: 560 / 315;\r\n  display: flex;\r\n\r\n  @include mu() {\r\n    margin-left: 17px;\r\n    max-width: 560px;\r\n    max-height: 315px;\r\n  }\r\n}\r\n\r\n.fa-shopify {\r\n  color: #85b043;\r\n}\r\n\r\n.video-playing {\r\n  app-image,\r\n  button {\r\n    display: none !important\r\n  }\r\n}\r\n\r\n.fa-shopify,\r\n.shopify-container span {\r\n  filter: drop-shadow(2px 4px 6px black);\r\n}\r\n\r\n.title-primary {\r\n  line-height: 1.4;\r\n  letter-spacing: 2.6px;\r\n}\r\n\r\n.title-overlay {\r\n  letter-spacing: 2.6px;\r\n  mix-blend-mode: color-burn;\r\n  color: #bdc6d2;\r\n  filter: drop-shadow(2px 4px 6px black);\r\n  background: linear-gradient(167deg, #844b92, #d49a20);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n}\r\n\r\n.partners-container {\r\n  -webkit-backdrop-filter: blur(3px);\r\n  backdrop-filter: blur(3px);\r\n  border: 1px solid rgba(236, 239, 241, 0.2);\r\n  background: rgb(214 214 214 / 35%);\r\n}\r\n\r\np.text-base {\r\n  filter: drop-shadow(2px 4px 6px black);\r\n}\r\n\r\n.text-column {\r\n  p {\r\n    line-height: 1.8;\r\n  }\r\n}\r\n\r\n.buttons-column {\r\n  > *:last-child {\r\n    flex: 0 0 clamp(120px, 100%, 240px);\r\n\r\n    &:before {\r\n      content: \"\";\r\n      position: absolute;\r\n      left: 0;\r\n      top: 50%;\r\n      -webkit-transform: translateY(-50%);\r\n      -ms-transform: translateY(-50%);\r\n      transform: translateY(-50%);\r\n      width: 1px;\r\n      height: 50px;\r\n      background: #fff;\r\n\r\n      @include md() {\r\n        top: 0;\r\n        left: 50%;\r\n        translate: -50% 0%;\r\n        width: 50px;\r\n        height: 1px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.trustpilot-container {\r\n  left: -3px;\r\n\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 3px;\r\n    width: 50px;\r\n    height: 1px;\r\n    background: #fff;\r\n  }\r\n}\r\n\r\n@keyframes slide-left-to-middle {\r\n  0% {\r\n    translate: -110% 0;\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    translate: 0 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n:host ::ng-deep {\r\n  @include mu() {\r\n    .trustpilot {\r\n      animation: slide-left-to-middle 1s ease-in-out forwards;\r\n    }\r\n  }\r\n\r\n  .p-button span {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .trustpilot {\r\n    max-width: 240px;\r\n  }\r\n}\r\n\r\n.play-ytb {\r\n  -webkit-transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n  width: 80px;\r\n  height: 50px;\r\n  background: 0 0;\r\n\r\n  span {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n.image-youtube {\r\n  app-image {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    border: 1px solid #fff;\r\n    inset: -1px;\r\n    z-index: -1;\r\n    box-shadow: -6px 0 12px 0 rgba(#d49a20, 0.2), 0 -6px 12px 0 rgba(#d49a20, 0.2);\r\n    transition: inset 0.2s ease-in-out;\r\n\r\n    @include mu() {\r\n      animation: slide-middle-to-top 0.5s ease-in-out forwards;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes slide-middle-to-top {\r\n  0% {\r\n    inset: -1px;\r\n  }\r\n  100% {\r\n    inset: -1rem;\r\n  }\r\n}\r\n\r\n.fade-out {\r\n  opacity: 0;\r\n  transition: opacity 1s ease;\r\n}\r\n\r\n.slide-middle-to-down {\r\n  transform: translateY(50%);\r\n  opacity: 0;\r\n  transition: transform 0.5s ease, opacity 0.5s ease;\r\n}\r\n\r\n.slide-up {\r\n  transform: translateY(-50%);\r\n  opacity: 0;\r\n  transition: transform 0s ease, opacity 0s ease;\r\n}\r\n\r\n.slide-top-to-middle {\r\n  transform: translateY(0);\r\n  opacity: 1;\r\n  transition: transform 0.5s ease, opacity 0.5s ease;\r\n}\r\n\r\n.custom-shape-divider-bottom-1719869309 {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  line-height: 0;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.custom-shape-divider-bottom-1719869309 svg {\r\n  position: relative;\r\n  display: block;\r\n  width: calc(129% + 1.3px);\r\n  height: 90px;\r\n}\r\n\r\n.custom-shape-divider-bottom-1719869309 .shape-fill {\r\n  fill: #121212;\r\n}\r\n\r\n:host::ng-deep {\r\n  @include md() {\r\n    .image-youtube iframe {\r\n      max-width: 100%;\r\n      aspect-ratio: 16 / 9;\r\n      height: auto;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
